export default __webpack_public_path__ + "static/media/belonging-colored.fa591c94.svg";